import APIService from './APIService';
import StorageService from './StorageService';

const TOKEN_EXPIRY_CACHE_KEY = 'gq_token_expiry';
const REFRESH_TOKEN_WHEN_MS_LEFT = 5 * 60 * 1000; // 5 minutes
const CHECK_EXPIRY_INTERVAL = 5 * 60 * 1000; // 5 minutes
const IGNORE_DIFF_MS = 5 * 60 * 1000; // Prevent parallel requests with small diff in expiry MS resetting the timer.

const timerFN = async () => {
    const storedExpiry = Number(StorageService.get(TOKEN_EXPIRY_CACHE_KEY));
    if (!Number.isFinite(storedExpiry) || storedExpiry <= Date.now()) {
        return;
    }
    const expiryInMS = storedExpiry - Date.now();
    if (
        expiryInMS <= REFRESH_TOKEN_WHEN_MS_LEFT &&
        !TokenExpiryTimer.isRefreshing
    ) {
        TokenExpiryTimer.isRefreshing = true;
        try {
            await APIService.me();
        } finally {
            TokenExpiryTimer.isRefreshing = false;
        }
    }
};

class TokenExpiryTimer {
    public static isRefreshing: boolean = false;

    static init() {
        setInterval(timerFN, CHECK_EXPIRY_INTERVAL + Math.random() * 1000);
    }

    static setNewExpiry(newExpiry: number) {
        if (!Number.isFinite(newExpiry)) {
            return;
        }
        const storedExpiry = Number(StorageService.get(TOKEN_EXPIRY_CACHE_KEY));
        const hasStoredExpiry = Number.isFinite(storedExpiry);
        const expiryDateUnix = Math.max(newExpiry, Date.now());
        const shouldUpdateExpiry =
            !hasStoredExpiry ||
            Math.abs(expiryDateUnix - storedExpiry) > IGNORE_DIFF_MS;
        if (shouldUpdateExpiry) {
            StorageService.set(TOKEN_EXPIRY_CACHE_KEY, expiryDateUnix);
        }
    }
}

export default TokenExpiryTimer;
